module.exports = __webpack_public_path__ + "static/media/avatar_gorilla.cd432101.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_gorilla.png
// module id = 383
// module chunks = 0